import { ControllerManager } from '@gui/controller/ControllerManager';

/**
 * Adds the mixerLayer to the mixer layer collection if not already present.
 */
export function addMixedLayerToCollection(): void {
    // 1. Get Mixer information:
    const mixerController = ControllerManager.getInstance().getMixerController();
    mixerController.run();

    const mixerLayer = mixerController.getMixerLayer();
    const simulationSet = mixerLayer.parentSimulationSet;
    if (!simulationSet) return;
    const collection = simulationSet.layerCollection;

    // 2. Add mixer layer to the collection if not already present:
    if (!collection.includes(mixerLayer)) {
        collection.push(mixerLayer);
    }

    // 2.1. Split layer in their categories:
    simulationSet.splitLayersByGroup();
}
